const ADDRESS_TYPES = {
    RESIDENTIAL: 'residential',
    BUSINESS: 'business',
};

export default ADDRESS_TYPES;
